import React, { useEffect, useState } from "react";
import "./ProductContentCard.scss";
import { useParams } from "react-router-dom";
import Breadcrumb from "../Breadcrum";
import Notfound from "../../pages/Notfound";

function ProductContentCard() {
  const { productName } = useParams();
  const [product, setProduct] = useState(null);

  const products = [
    {
      imageUrl: "./assets/img/api-excipients/Picture1.png",
      imageAlt: "1-Pentanol",
      imageTitle: "1-Pentanol",
      productName: "LIGHT LIQUID PARAFFIN OIL",
      chemicalName: "White Mineral Oil (Petroleum)",
      casNumber: "8042-47-5",
      chemicalFormula: "CnH2n+2",
      density: "0.810 – 0.880 kg/m3 ASTM D 1298",
      description:
        "Light liquid paraffin oil is the highest grade, refined version of mineral oils and is an unsaturated hydrocarbon derived from petroleum. Some common petroleum refining methods for obtaining light liquid paraffin oil are thermal fractionation and chemical fractionation.",
      additionalInfo:
        "The main characteristic of paraffin liquid light is its transparency. The purity level of this mineral oil rises to 99% and has a range of uses across industries.",
      specifications: [
        { label: "Chemical Name", value: "White Mineral Oil (Petroleum)" },
        { label: "CAS No", value: "8042-47-5" },
        { label: "% (Weight)", value: "100" },
        { label: "Physical state", value: "Liquid" },
        { label: "Pour Point", value: "-12°C ASTM D 97" },
        { label: "Flash point", value: "Closed cup: > 150°C" },
        { label: "Solubility in water", value: "Immiscible" },
        { label: "Vapour density", value: ">1 [Air = 1]" },
        { label: "Appearance", value: "Colourless, transparent, oily liquid" },
        { label: "pH (as supplied)", value: "Not Applicable" },
        { label: "Odour", value: "None" },
        {
          label: "Vapour pressure",
          value: "<0.013 kPa [<0.1 mm Hg] [room temperature]",
        },
        { label: "Flammability", value: "Not Applicable" },
      ],
      industries: [
        {
          title: "Pharmaceutical and Cosmetic Industry",
          items: [
            {
              label: "Sweetening Agent:",
              description:
                "Base for Ointments and Creams: Used as an emollient in topical formulations to soothe and protect the skin.",
            },
            {
              label: "Laxatives:",
              description:
                "An ingredient in medicinal formulations like liquid paraffin laxatives.",
            },
            {
              label: "Moisturizers:",
              description:
                "Incorporated into lotions and creams for its hydrating properties.",
            },
            {
              label: "Hair Care Products:",
              description:
                "Used in hair oils, conditioners, and styling products for its non-greasy lubrication.",
            },
          ],
        },
        {
          title: "Food and Beverage Industry (Applicable for Food Grade)",
          items: [
            {
              label: "Food-Grade Applications:",
              description:
                "Acts as a release agent, anti-sticking agent, or lubricant in food processing.",
            },
            {
              label: "Coating for Fruits and Vegetables:",
              description:
                "Applied as a thin layer to preserve freshness and gloss.",
            },
          ],
        },
        {
          title: "Industrial Applications",
          items: [
            {
              label: "Lubricants:",
              description:
                "Serves as a lubricant in machinery where food-grade oils are required.",
            },
            {
              label: "Metalworking Fluids:",
              description:
                "Used in cutting, grinding, and machining processes as a cooling agent.",
            },
            {
              label: "Plastic and Polymer Industry:",
              description: "Functions as a plasticizer or mold release agent.",
            },
          ],
        },
        {
          title: "Chemical Synthesis and Industrial Processes",
          items: [
            {
              label: "Carrier Fluid:",
              description:
                "Acts as a medium in chemical reactions requiring a stable, inert liquid.",
            },
            {
              label: "Diluent for Additives:",
              description:
                "Helps in blending additives like dyes, pigments, and fragrances.",
            },
          ],
        },
        {
          title: "Textile and Leather Industry",
          items: [
            {
              label: "Softener and Finishing Agent:",
              description: "Provides a smooth texture to fabrics and leather.",
            },
          ],
        },
        {
          title: "Agriculture",
          items: [
            {
              label: "Pesticide Carrier:",
              description:
                "Used as a medium for formulating pesticides and herbicides.",
            },
          ],
        },
        {
          title: "Miscellaneous Uses",
          items: [
            {
              label: "Candles and Polishes:",
              description: "As a base in wax and polishing agents.",
            },
            {
              label: "Printing Inks:",
              description:
                "Enhances ink properties for specific industrial applications.",
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/Picture2.png",
      imageAlt: "Hexadeca 1_ol",
      imageTitle: "Hexadeca 1_ol",
      productName: "CETYL ALCOHOL",
      chemicalName: "Hexadeca 1_ol",
      casNumber: "36653-82-4",
      chemicalFormula: "C16H34O",
      molecularWeight: "242.45 g/mol",
      description:
        "Cetyl Alcohol is a high-quality, long-chain fatty alcohol widely used in various applications due to its emollient, thickening, and stabilizing properties.",
      additionalInfo:
        "Derived from natural sources such as palm oil or synthesized chemically, this versatile compound is highly valued in the cosmetics, personal care, and pharmaceutical industries.",

      specifications: [
        { label: "Chemical Name", value: "Hexadeca 1-ol" },
        { label: "CAS No", value: "36653-82-4" },
        { label: "EC Number", value: "253-149-0" },
        { label: "Composition", value: "Cetyl alcohol Min. 98%" },
        { label: "Molecular Weight", value: "242.45 g/mol" },
        { label: "Molecular Formula", value: "C16H34O" },
        {
          label: "Form",
          value: "White flakes / pastilles (clear liquid when melted)",
        },
        { label: "Color", value: "Colourless" },
        { label: "Odor", value: "Odorless" },
        { label: "Flash Point", value: "Ca 180 °C (Ca 356 °F)" },
        { label: "Ignition Temperature", value: "250 °C (482 °F)" },
      ],

      industries: [
        {
          title: "Cosmetics & Personal Care Products",
          items: [
            {
              label: "Emollient, Emulsifier, and Thickening Agent:",
              description:
                "Used in creams, lotions, shampoos, and conditioners to enhance texture and stability.",
            },
            {
              label: "Product Stability Enhancer:",
              description:
                "Imparts a luxurious, smooth texture to formulations, improving their overall consistency.",
            },
          ],
        },
        {
          title: "Pharmaceuticals",
          items: [
            {
              label: "Stabilizer and Thickener:",
              description:
                "Used in ointments, creams, and topical medications to enhance consistency and efficacy.",
            },
            {
              label: "Active Ingredient Delivery:",
              description:
                "Helps in improving the formulation's consistency for effective delivery of active ingredients.",
            },
          ],
        },
        {
          title: "Industrial Uses",
          items: [
            {
              label: "Surfactants and Detergents Production:",
              description:
                "Plays a role in the manufacturing of cleaning and foaming agents.",
            },
            {
              label: "Lubricant:",
              description:
                "Functions as a lubricant in various industrial applications.",
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/Picture3.png",
      imageAlt: "D Panthenol",
      imageTitle: "D Panthenol",
      productName: "D PANTHENOL",
      chemicalName:
        "Panthenol 98% liquid; Pro-vitamin B5; D Panthenyl alcohol; Dexpanthenol",
      casNumber: "81-13-0",
      chemicalFormula: "C9H19NO4",
      molecularWeight: "205.25 g/mol",
      description:
        "Panthenol (also called pantothenol) is the alcohol analog of pantothenic acid (vitamin B5), and is thus a provitamin of B5. It is used widely as a high-performance moisturizer, soothing agent, softening agent, and anti-irritant agent.",
      additionalInfo:
        "It also helps your skin build up a barrier against irritation and water loss. Used in several skin care and hair care products. It is an odorless, slightly bitter, highly viscous, transparent, and colorless liquid at room temperature.",

      specifications: [
        { label: "Chemical Name", value: "Dexpanthenol" },
        { label: "CAS No", value: "81-13-0" },
        { label: "Appearance", value: "Liquid, viscous" },
        { label: "Color", value: "Colorless to slightly yellow." },
        { label: "Odor", value: "Odorless" },
        { label: "Density", value: "1.2 g/cm³ at 20°C" },
        { label: "Molecular Weight", value: "205.25 g/mol" },
        { label: "Molecular Formula", value: "C9H19NO4" },
        { label: "Melting Point", value: "-25°C" },
        { label: "Boiling Point", value: "235.6°C" },
        { label: "Flash Point", value: "150.5°C" },
      ],

      industries: [
        {
          title: "Cosmetics & Personal Care Products",
          items: [
            {
              label: "Skin Care",
              description: [
                "Acts as a moisturizer, improving skin hydration and reducing dryness.",
                "Helps in healing minor wounds and soothing irritated skin.",
                "Reduces redness and inflammation, making it ideal for sensitive or acne-prone skin.",
              ],
            },
            {
              label: "Hair Care",
              description: [
                "Strengthens hair by improving elasticity and moisture retention.",
                "Adds shine, softness, and volume to hair.",
                "Prevents hair breakage and split ends.",
              ],
            },
            {
              label: "Nail Care",
              description: [
                "Improves nail strength and flexibility.",
                "Prevents brittleness and enhances the overall health of nails.",
              ],
            },
          ],
        },
        {
          title: "Pharmaceuticals",
          items: [
            {
              label: "Wound Healing",
              description: [
                "Promotes the regeneration of skin cells, accelerating wound and burn healing.",
                "Used in ointments and creams for treating cuts, scrapes, and minor burns.",
              ],
            },
            {
              label: "Dermatological Treatments",
              description: [
                "Helps in the treatment of eczema, dermatitis, and other inflammatory skin conditions.",
                "Used in products for diaper rash and sunburn relief.",
              ],
            },
          ],
        },
        {
          title: "Industrial Uses",
          items: [
            {
              label: "Animal Feed",
              description: [
                "Serves as a supplement to improve the coat and skin health of livestock.",
                "Enhances the immune response in animals.",
              ],
            },
            {
              label: "Food Industry",
              description: [
                "Used as an additive in food and beverages for its nutrient-enriching properties.",
              ],
            },
            {
              label: "Pharmaceutical Formulations",
              description: [
                "Incorporated in syrups and tablets to boost overall health and energy levels.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/Picture4.png",
      imageAlt: "Ascorbic Acid",
      imageTitle: "Ascorbic Acid",
      productName: "ASCORBIC ACID",
      chemicalName: "Vitamin C",
      casNumber: "50-81-7",
      chemicalFormula: "C6H8O6",
      molecularWeight: "176.12 g/mol",
      description:
        "Ascorbic acid is a water-soluble vitamin. It occurs as a white or slightly yellow crystal or powder with a slight acidic taste. On exposure to light, it gradually darkens. In the dry state, it is reasonably stable in air, but in solution, it rapidly oxidizes.",
      additionalInfo:
        "Ascorbic acid is found naturally in citrus fruits and many vegetables. It is an essential nutrient in human diets, necessary to maintain connective tissue and bone. Its biologically active form, vitamin C, functions as a reducing agent and coenzyme in several metabolic pathways. Vitamin C is considered an antioxidant.",

      specifications: [
        {
          label: "Chemical Name",
          value: "Antiscorbutic factor L-Threoascorbic acid Vitamin C",
        },
        { label: "CAS No", value: "50-81-7" },
        { label: "EC Number", value: "200-066-2" },
        {
          label: "Appearance",
          value: "Solid (Crystals solid, Powdered solid)",
        },
        { label: "Molecular Weight", value: "176.12 g/mol" },
        { label: "Molecular Formula", value: "C6H8O6" },
        { label: "pH", value: "1.0 - 2.5 at 176 g/l at 25 °C" },
        { label: "Therapeutic Category", value: "Oral" },
        { label: "Melting Point", value: "190 - 192 °C" },
        { label: "Odor", value: "Odorless" },
        { label: "Taste", value: "Acid, Sharp, Pleasant" },
      ],

      industries: [
        {
          title: "Food and Beverage Industry",
          items: [
            {
              label: "Preservative",
              description: [
                "Prevents oxidation and spoilage in processed foods and beverages.",
              ],
            },
            {
              label: "Antioxidant",
              description: [
                "Maintains color, flavor, and nutrients in products like juices, jams, and canned goods.",
              ],
            },
            {
              label: "Fortification",
              description: [
                "Adds nutritional value to cereals, snacks, and beverages.",
              ],
            },
          ],
        },
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Dietary Supplements",
              description: [
                "Used in tablets, capsules, and powders to prevent or treat vitamin C deficiency (scurvy).",
              ],
            },
            {
              label: "Therapeutic Use",
              description: [
                "Supports immune function, aids in wound healing, and acts as an antioxidant to protect cells from damage.",
              ],
            },
          ],
        },
        {
          title: "Cosmetic Industry",
          items: [
            {
              label: "Skincare Products",
              description: [
                "Included in creams, serums, and masks for its antioxidant properties and ability to brighten skin tone, reduce hyperpigmentation, and promote collagen synthesis.",
              ],
            },
            {
              label: "Anti-aging",
              description: [
                "Helps reduce fine lines and wrinkles by supporting skin elasticity.",
              ],
            },
          ],
        },
        {
          title: "Industrial Applications",
          items: [
            {
              label: "Anti-browning Agent",
              description: [
                "Prevents discoloration in fresh-cut fruits and vegetables.",
              ],
            },
            {
              label: "pH Adjuster",
              description: [
                "Used in the chemical industry to stabilize formulations.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/GLYCERIN.jpg",
      imageAlt: "Glycerin",
      imageTitle: "Glycerin",
      productName: "GLYCERIN",
      chemicalName: "Vegetable Glycerine, Glycerol, Oleochemical",
      casNumber: "56-81-5",
      chemicalFormula: "C3H8O3",
      molecularWeight: "92.09 g/mol",
      description:
        "Glycerine produced from vegetable oil, also known as vegetable glycerin, is an oleochemical used in a variety of applications, including food, pharma, personal care products, and a whole range of other industrial applications like paints, resins, and even explosives.",
      additionalInfo:
        "Our quality meets both domestic and international regulatory requirements, including that of the Pharmacopeias, Food Codex and Food Safety and Standards Authority of India, as also the various Cosmetic Directives (EU, USA, Japan & India).",

      specifications: [
        { label: "Chemical Name", value: "Glycerol" },
        { label: "CAS No", value: "56-81-5" },
        { label: "EC Number", value: "200-289-5" },
        {
          label: "Composition",
          value: "% Glycerol - >99.50,  % Water - 0.10 – 0.30",
        },
        { label: "Molecular Weight", value: "92.09 g/mol" },
        { label: "Molecular Formula", value: "C3H8O3" },
        { label: "Form", value: "Clear Viscous Liquid" },
        { label: "Color", value: "Colourless" },
        { label: "Odor", value: "Odorless" },
        { label: "Flash Point", value: "199 °C (390 °F)" },
        { label: "Ignition Temperature", value: "370 °C (698 °F)" },
      ],

      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Topical Applications",
              description: [
                "Used in creams, ointments, and lotions for its moisturizing properties.",
              ],
            },
            {
              label: "Cough Syrups",
              description: ["Serves as a soothing agent."],
            },
            {
              label: "Suppositories",
              description: ["Acts as a laxative for bowel regulation."],
            },
            {
              label: "Capsules and Tablets",
              description: ["Works as a solvent or plasticizer."],
            },
          ],
        },
        {
          title: "Personal Care & Cosmetics",
          items: [
            {
              label: "Moisturizers and Skincare Products",
              description: ["Prevents dryness by retaining moisture."],
            },
            {
              label: "Toothpaste",
              description: [
                "Helps maintain smooth texture and prevents drying out.",
              ],
            },
            {
              label: "Haircare Products",
              description: ["Adds moisture and shine to hair."],
            },
            {
              label: "Soap Manufacturing",
              description: ["Provides transparency and emollient properties."],
            },
          ],
        },
        {
          title: "Food & Beverage Industry",
          items: [
            {
              label: "Sweetener",
              description: ["Used in sugar-free and low-sugar products."],
            },
            {
              label: "Preservative",
              description: ["Prevents moisture loss in food."],
            },
            {
              label: "Texturizer",
              description: [
                "Improves consistency in baked goods, candies, and dairy products.",
              ],
            },
          ],
        },
        {
          title: "Industrial Applications",
          items: [
            {
              label: "Antifreeze",
              description: [
                "Used in automotive applications for its low freezing point.",
              ],
            },
            {
              label: "Plastic Manufacturing",
              description: ["Serves as a plasticizer."],
            },
            {
              label: "Explosives",
              description: [
                "A critical ingredient in nitroglycerin production.",
              ],
            },
            {
              label: "Paints and Coatings",
              description: ["Used to enhance flow and prevent cracking."],
            },
          ],
        },
        {
          title: "Health & Wellness",
          items: [
            {
              label: "Vaping Liquids",
              description: [
                "Glycerin is used as a base for e-cigarette liquids.",
              ],
            },
            {
              label: "Pet Care",
              description: ["Included in pet treats and medications."],
            },
            {
              label: "Herbal Extractions",
              description: ["Acts as a solvent in non-alcoholic tinctures."],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/CAFFEINE-ANHYDROUS.jpg",
      imageAlt: "Caffeine Anhydrous",
      imageTitle: "Caffeine Anhydrous",
      productName: "CAFFEINE ANHYDROUS",
      chemicalName: "Hexadeca 1_ol",
      casNumber: "58-08-2",
      chemicalFormula: "C8H10N4O2",
      molecularWeight: "194.19 g/mol",
      description:
        "Caffeine anhydrous is a dehydrated form of caffeine, meaning it has been processed to remove water. It appears as a white crystalline powder and is derived from natural sources such as coffee beans, tea leaves, or synthesized artificially.",
      additionalInfo:
        "It is highly concentrated and provides a more potent and precise dosage of caffeine compared to its hydrated counterparts.",
      specifications: [
        { label: "CAS No", value: "58-08-2" },
        { label: "EC Number", value: "200-362-1" },
        {
          label: "Synonyms",
          value:
            "3 7-Dihydro-1 3 ,7-Trimethyl-1H-Purine-2, 6-Dione, 1 3 7 Trimethyl xanthine, Methyl theobromide",
        },
        { label: "Molecular Weight", value: "194.19 g/mol" },
        { label: "Molecular Formula", value: "C8H10N4O2" },
        { label: "Form", value: "Crystalline powder or crystals" },
        { label: "Color", value: "White" },
        { label: "Odor", value: "Odorless" },
        { label: "Melting Point", value: "235 – 237 °C" },
        { label: "Density", value: "1.23 g/cm³ at 18°C" },
      ],
      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Stimulant Drugs",
              description: [
                "Used in medications to combat fatigue and increase alertness.",
              ],
            },
            {
              label: "Pain Relievers",
              description: [
                "Commonly combined with aspirin or acetaminophen to enhance effectiveness.",
              ],
            },
            {
              label: "Respiratory Treatments",
              description: [
                "Included in treatments for conditions like apnea in newborns.",
              ],
            },
          ],
        },
        {
          title: "Food & Beverage Industry",
          items: [
            {
              label: "Stimulant Drugs",
              description: [
                "Used in medications to combat fatigue and increase alertness.",
              ],
            },
            {
              label: "Pain Relievers",
              description: [
                "Commonly combined with aspirin or acetaminophen to enhance effectiveness.",
              ],
            },
            {
              label: "Respiratory Treatments",
              description: [
                "Included in treatments for conditions like apnea in newborns.",
              ],
            },
          ],
        },
        {
          title: "Cosmetics Industry",
          items: [
            {
              label: "Anti-cellulite Products",
              description: ["Improves skin texture by promoting blood flow."],
            },
            {
              label: "Eye Creams",
              description: [
                "Reduces puffiness and dark circles by constricting blood vessels.",
              ],
            },
            {
              label: "Shampoos and Hair Care",
              description: ["Stimulates hair follicles and reduces hair loss."],
            },
          ],
        },
      ],
    },
    {
      imageUrl:
        "./assets/img/api-excipients/SODIUM-LAURYL-ETHER-SULFATE-70.jpg",
      imageAlt: "Sodium Lauryl Ether Sulfate 70%",
      imageTitle: "Sodium Lauryl Ether Sulfate 70%",
      productName: "SODIUM LAURYL ETHER SULFATE 70%",
      chemicalName:
        "Sodium Alkyl Ethoxy Sulphate, Sodium C10-16 Alkyl Ethoxy Sulphate",
      casNumber: "68585-34-2",
      chemicalFormula: "C12H25(OCH2CH2)nOSO3Na (n ≈ 3)",
      molecularWeight: "376.48 g/mol",
      description:
        "Sodium Lauryl Ether Sulfate 70% is a surfactant derived from natural alcohols and ethoxylated to provide excellent foaming and cleansing properties.",
      additionalInfo:
        "It is a widely used anionic detergent compatible with various additives and is effective in both soft and hard water.",
      specifications: [
        { label: "CAS No", value: "68585-34-2" },
        { label: "EC Number", value: "500-223-8" },
        {
          label: "Composition",
          value:
            "Sodium Lauryl Ether Sulfate: 70%, Water: ~30%, Trace impurities: Ethylene oxide and dioxane (within safe limits)",
        },
        { label: "Molecular Weight", value: "376.48 g/mol" },
        { label: "Molecular Formula", value: "C12H25(OCH2CH2)nOSO3Na (n ≈ 3)" },
        { label: "Form", value: "Viscous liquid or paste" },
        { label: "Color", value: "White to pale yellow" },
        { label: "Odor", value: "Mild, characteristic odor (soapy)" },
        { label: "Flash Point", value: ">93°C (199°F)" },
        {
          label: "Ignition Temperature",
          value: "Not easily ignitable under standard conditions",
        },
      ],
      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Stimulant Drugs",
              description: [
                "Used in medications to combat fatigue and increase alertness.",
              ],
            },
            {
              label: "Pain Relievers",
              description: [
                "Commonly combined with aspirin or acetaminophen to enhance effectiveness.",
              ],
            },
            {
              label: "Respiratory Treatments",
              description: [
                "Included in treatments for conditions like apnea in newborns.",
              ],
            },
            {
              label: "Medicated Shampoos and Cleansers",
              description: [
                "Used in medicated shampoos and cleansers for its effective emulsifying and foaming properties.",
              ],
            },
            {
              label: "Drug Formulation Aid",
              description: [
                "Aids in drug formulation processes by acting as a wetting and dispersing agent.",
              ],
            },
          ],
        },
        {
          title: "Food & Beverage Industry",
          items: [
            {
              label: "Stimulant Drugs",
              description: [
                "Used in medications to combat fatigue and increase alertness.",
              ],
            },
            {
              label: "Pain Relievers",
              description: [
                "Commonly combined with aspirin or acetaminophen to enhance effectiveness.",
              ],
            },
            {
              label: "Respiratory Treatments",
              description: [
                "Included in treatments for conditions like apnea in newborns.",
              ],
            },
            {
              label: "Processing Aid and Emulsifier",
              description: [
                "Occasionally used as a processing aid or emulsifier in non-consumable applications (e.g., cleaning solutions for food processing equipment).",
              ],
            },
            {
              label: "Hygiene Support",
              description: [
                "Not directly used as a food ingredient but supports hygiene in food preparation setups.",
              ],
            },
          ],
        },
        {
          title: "Cosmetics Industry",
          items: [
            {
              label: "Anti-cellulite Products",
              description: ["Improves skin texture by promoting blood flow."],
            },
            {
              label: "Eye Creams",
              description: [
                "Reduces puffiness and dark circles by constricting blood vessels.",
              ],
            },
            {
              label: "Shampoos and Hair Care",
              description: ["Stimulates hair follicles and reduces hair loss."],
            },
          ],
        },
        {
          title: "Industrial Applications",
          items: [
            {
              label: "Cleaning Agents",
              description: [
                "Commonly employed in cleaning agents, such as industrial detergents and degreasers, due to its excellent surfactant properties.",
              ],
            },
            {
              label: "Textile and Leather Industry",
              description: [
                "Utilized in textile, leather, and dye industries for wetting and scouring processes.",
              ],
            },
          ],
        },
        {
          title: "Personal Care Products",
          items: [
            {
              label: "Shampoos, Body Washes, and Liquid Soaps",
              description: [
                "Essential in manufacturing shampoos, body washes, toothpastes, and liquid soaps.",
              ],
            },
            {
              label: "Cleansing Agent",
              description: [
                "Provides rich lather and effective cleansing while being cost-efficient.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/PARACETAMOL-POWDER.jpg",
      imageAlt: "Paracetamol Powder",
      imageTitle: "Paracetamol Powder",
      productName: "PARACETAMOL POWDER",
      chemicalName: "Acetaminophen",
      casNumber: "103-90-2",
      chemicalFormula: "C8H9NO2",
      molecularWeight: "151.16 g/mol",
      description:
        "Paracetamol, also known as Acetaminophen, is a widely used analgesic (pain reliever) and antipyretic (fever reducer). It is a fine crystalline powder, odorless and white in color, commonly formulated into tablets, capsules, syrups, and other pharmaceutical forms.",
      additionalInfo:
        "With its high efficacy and low side effect profile when used at recommended dosages, Paracetamol is a first-line medication for treating mild to moderate pain and fever across all age groups.",
      specifications: [
        { label: "Chemical Name", value: "Acetaminophen" },
        { label: "CAS No", value: "103-90-2" },
        { label: "EC Number", value: "203-157-5" },
        {
          label: "Composition",
          value: "Pure Paracetamol, typically >98% purity",
        },
        { label: "Molecular Weight", value: "151.16 g/mol" },
        { label: "Molecular Formula", value: "C8H9NO2" },
        { label: "Form", value: "Fine crystalline powder" },
        { label: "Color", value: "White or almost white" },
        { label: "Odor", value: "Odorless" },
        { label: "Flash Point", value: "170°C (338°F)" },
        { label: "Ignition Temperature", value: "~420°C" },
      ],
      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Active Pharmaceutical Ingredient (API)",
              description: [
                "Used as an active pharmaceutical ingredient (API) in analgesic and antipyretic medications.",
              ],
            },
          ],
        },
        {
          title: "Formulation Additives",
          items: [
            {
              label: "Dosage Forms",
              description: [
                "Used in tablet, capsule, syrup, and suspension formulations.",
              ],
            },
          ],
        },
        {
          title: "Industrial Use",
          items: [
            {
              label: "Bulk Drug Production",
              description: [
                "For bulk production of pain relief and fever-reducing drugs.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/SODIUM-BENZOATE.jpg",
      imageAlt: "Sodium Benzoate",
      imageTitle: "Sodium Benzoate",
      productName: "SODIUM BENZOATE",
      chemicalName: "Sodium Benzoate",
      casNumber: "532-32-1",
      chemicalFormula: "C7H5NaO2",
      molecularWeight: "144.11 g/mol",
      description:
        "Sodium benzoate is a widely used preservative in the food, beverage, cosmetic, and pharmaceutical industries.",
      additionalInfo:
        "It is a sodium salt of benzoic acid and is effective in inhibiting the growth of bacteria, yeast, and fungi, which is why it is used to extend the shelf life of various products.",
      specifications: [
        { label: "CAS No", value: "532-32-1" },
        { label: "EC Number", value: "208-534-8" },
        {
          label: "Composition",
          value:
            "Sodium benzoate is composed of the sodium salt of benzoic acid (C6H5COONa), synthesized by neutralizing benzoic acid with sodium hydroxide or sodium carbonate.",
        },
        { label: "Molecular Weight", value: "144.11 g/mol" },
        { label: "Molecular Formula", value: "C7H5NaO2" },
        { label: "Form", value: "White crystalline powder or granular form" },
        { label: "Color", value: "White to off-white" },
        { label: "Odor", value: "Odorless or faintly sweet" },
        { label: "Melting Point", value: "300°C" },
        { label: "Density", value: "1.44 g/cm³" },
        {
          label: "Flash Point",
          value: "Not flammable under normal conditions",
        },
        { label: "Ignition Temperature", value: "Approximately 500°C" },
      ],

      industries: [
        {
          title: "Food and Beverage Industry",
          items: [
            {
              label: "Preservative",
              description: [
                "Sodium benzoate is widely used as a preservative in various foods and beverages, including soft drinks, fruit juices, pickles, sauces, jams, and salad dressings. It helps prevent the growth of harmful bacteria, yeast, and molds.",
              ],
            },
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          items: [
            {
              label: "Product Preservation",
              description: [
                "In cosmetics, sodium benzoate is used to preserve products like shampoos, lotions, deodorants, and creams. It ensures that these products remain safe and effective over time by preventing microbial contamination.",
              ],
            },
          ],
        },
        {
          title: "Pharmaceuticals",
          items: [
            {
              label: "Preservative in Medications",
              description: [
                "Sodium benzoate is used in some pharmaceutical formulations, such as syrups and liquid medications, to prevent microbial growth and extend shelf life. It also serves as an excipient in some drugs.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/POTASSIUM-SORBATE.jpg",
      imageAlt: "Potassium Sorbate",
      imageTitle: "Potassium Sorbate",
      productName: "POTASSIUM SORBATE",
      chemicalName: "Potassium Sorbate",
      casNumber: "24634-61-5",
      chemicalFormula: "C6H7KO2",
      molecularWeight: "150.22 g/mol",
      description:
        "Potassium sorbate is the potassium salt of sorbic acid, widely used as a preservative in the food, beverage, cosmetic, and pharmaceutical industries.",
      additionalInfo:
        "It inhibits the growth of molds, yeasts, and other microorganisms, helping to extend the shelf life of various products.",
      specifications: [
        { label: "CAS No", value: "24634-61-5" },
        { label: "EC Number", value: "246-376-1" },
        { label: "Composition", value: "Potassium salt of sorbic acid" },
        { label: "Molecular Weight", value: "150.22 g/mol" },
        { label: "Molecular Formula", value: "C6H7KO2" },
        {
          label: "Form",
          value: "White to off-white crystalline powder or granular form",
        },
        { label: "Color", value: "White to pale yellow" },
        { label: "Odor", value: "Odorless or faintly characteristic" },
        { label: "Melting Point", value: "250°C (decomposes before melting)" },
        { label: "Density", value: "1.36 g/cm³" },
        {
          label: "Flash Point",
          value: "Not flammable under normal conditions",
        },
        { label: "Ignition Temperature", value: "Approximately 400°C" },
      ],

      industries: [
        {
          title: "Food and Beverage Industry",
          items: [
            {
              label: "Preservative",
              description: [
                "Potassium sorbate is commonly used as a preservative in various food and beverage products, such as cheeses, baked goods, dried fruits, syrups, pickles, and fruit juices. It helps prevent the growth of molds, yeasts, and bacteria, thus extending product shelf life.",
              ],
            },
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          items: [
            {
              label: "Product Preservation",
              description: [
                "In cosmetics and personal care products like lotions, shampoos, deodorants, and creams, potassium sorbate acts as a preservative to prevent microbial contamination. It helps maintain the safety and efficacy of these products over time.",
              ],
            },
          ],
        },
        {
          title: "Pharmaceuticals",
          items: [
            {
              label: "Preservative in Medications",
              description: [
                "Potassium sorbate is used in pharmaceutical formulations to prevent microbial contamination and ensure product stability.",
              ],
            },
          ],
        },
        {
          title: "Agriculture",
          items: [
            {
              label: "Fungicide",
              description: [
                "Potassium sorbate can be used as a fungicide in some agricultural products, such as in certain pesticides and plant growth products.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/ACETIC-ACID.jpg",
      imageAlt: "Acetic Acid",
      imageTitle: "Acetic Acid",
      productName: "ACETIC ACID",
      chemicalName: "Acetic Acid",
      casNumber: "64-19-7",
      chemicalFormula: "C₂H₄O₂",
      molecularWeight: "60.05 g/mol",
      description:
        "Acetic acid is a colorless, pungent organic liquid that is the main component of vinegar (in which it is present at a concentration of around 4–8%).",
      additionalInfo:
        "It is widely used in the chemical, food, and pharmaceutical industries. Acetic acid is known for its acidic properties and is used as a solvent, preservative, and chemical reagent.",

      specifications: [
        { label: "CAS No", value: "64-19-7" },
        { label: "EC Number", value: "200-580-7" },
        { label: "Composition", value: "A carboxylic acid" },
        { label: "Molecular Weight", value: "60.05 g/mol" },
        { label: "Molecular Formula", value: "C₂H₄O₂" },
        { label: "Form", value: "Colorless liquid" },
        { label: "Color", value: "Colorless" },
        { label: "Odor", value: "Strong, pungent, vinegar-like odor" },
        { label: "Melting Point", value: "16.6°C (61.88°F)" },
        { label: "Boiling Point", value: "118.1°C (244.58°F)" },
        { label: "Density", value: "1.049 g/cm³ at 20°C" },
        { label: "Flash Point", value: "39°C (102.2°F) (closed cup)" },
        { label: "Ignition Temperature", value: "465°C (869°F)" },
      ],

      industries: [
        {
          title: "Food Industry",
          items: [
            {
              label: "Preservative and Flavoring Agent",
              description: [
                "Used as a preservative, flavoring agent, and acidulant in food products. A key component of vinegar, widely used in cooking, pickling, and as a condiment. Helps balance pH in food items.",
              ],
            },
          ],
        },
        {
          title: "Chemical Industry",
          items: [
            {
              label: "Chemical Production",
              description: [
                "A crucial raw material in the production of acetic anhydride, acetate esters, solvents, coatings, and plastics.",
              ],
            },
          ],
        },
        {
          title: "Pharmaceuticals",
          items: [
            {
              label: "Solvent and Medical Use",
              description: [
                "Used as a solvent in the production of medications and in medical treatments for ear infections and as a topical antiseptic.",
              ],
            },
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          items: [
            {
              label: "pH Balancer and Exfoliant",
              description: [
                "Used in hair care products like shampoos and conditioners for pH balance and in skin care products for exfoliation and texture improvement.",
              ],
            },
          ],
        },
        {
          title: "Agriculture",
          items: [
            {
              label: "Herbicide and pH Regulator",
              description: [
                "Sometimes used in herbicides for weed control and as a pH regulator in agricultural solutions.",
              ],
            },
          ],
        },
        {
          title: "Cleaning Products",
          items: [
            {
              label: "Household Cleaner",
              description: [
                "Used in household cleaning products due to antibacterial and acidic properties. Helps dissolve mineral deposits, lime scale, and soap scum.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/CITRIC-ACID.jpg",
      imageAlt: "Citric Acid (Anhydrous)",
      imageTitle: "Citric Acid (Anhydrous)",
      productName: "CITRIC ACID (ANHYDROUS)",
      chemicalName: "Citric Acid (Anhydrous)",
      casNumber: "77-92-9",
      chemicalFormula: "C6H8O7",
      molecularWeight: "192.13 g/mol",
      description:
        "Citric acid (anhydrous) is a naturally occurring organic acid found in citrus fruits. It is a colorless, crystalline substance commonly used in the food, beverage, pharmaceutical, and cosmetic industries.",
      additionalInfo:
        "Citric acid is a strong acid with many applications, including as a preservative, flavor enhancer, and pH adjuster. The anhydrous form of citric acid is a more concentrated, water-free version, typically used in industrial and laboratory applications.",
      specifications: [
        { label: "CAS No", value: "77-92-9" },
        { label: "EC Number", value: "201-069-1" },
        {
          label: "Composition",
          value:
            "Citric acid is composed of three carboxyl groups and one hydroxyl group - making it a tribasic acid. The anhydrous form refers to citric acid without water molecules in its crystalline structure.",
        },
        { label: "Molecular Weight", value: "192.13 g/mol" },
        { label: "Molecular Formula", value: "C6H8O7" },
        { label: "Form", value: "White crystalline powder or granules" },
        { label: "Color", value: "White to off-white" },
        { label: "Odor", value: "Odorless or faintly characteristic" },
        { label: "Melting Point", value: "153°C (307.4°F)" },
        {
          label: "Decomposition Temperature",
          value: "175°C (decomposes before boiling)",
        },
        { label: "Density", value: "1.665 g/cm³" },
        { label: "Flash Point", value: "Not flammable" },
        { label: "Ignition Temperature", value: "Not applicable" },
      ],
      industries: [
        {
          title: "Food and Beverage Industry",
          items: [
            {
              label: "Preservative and Flavor Enhancer",
              description: [
                "Citric acid is widely used as a preservative, acidulant, and flavor enhancer. It helps adjust pH levels, stabilize products, and enhance the tartness of foods and beverages such as soft drinks, fruit juices, candies, jams, and gelatins.",
              ],
            },
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          items: [
            {
              label: "pH Balancer and Skin Care Ingredient",
              description: [
                "Used to balance pH and improve product stability in shampoos, conditioners, lotions, and facial cleansers. Provides exfoliating and skin-toning properties.",
              ],
            },
          ],
        },
        {
          title: "Pharmaceuticals",
          items: [
            {
              label: "Excipient and pH Adjuster",
              description: [
                "Citric acid is used in pharmaceutical formulations as an excipient, pH adjuster, and preservative to ensure product stability and effectiveness.",
              ],
            },
          ],
        },
        {
          title: "Cleaning Products",
          items: [
            {
              label: "Descaling and Household Cleaner",
              description: [
                "Due to its acidic nature, citric acid is effective in removing lime scale, hard water deposits, and mineral buildups. Commonly found in household cleaners, descaling agents, and dishwashing products.",
              ],
            },
          ],
        },
        {
          title: "Industrial Applications",
          items: [
            {
              label: "Manufacturing and Chelating Agent",
              description: [
                "Citric acid is used in industrial applications such as the manufacturing of detergents, textiles, and dyes. It also serves as a chelating agent in metalworking and in the production of biodegradable plastics.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/chem_20.jpg",
      imageAlt: "1-Pentanol",
      imageTitle: "1-Pentanol",
      productName: "PROPYL GALLATE",
      chemicalName: "Propyl Gallate",
      casNumber: "121-79-9",
      chemicalFormula: "C₁₁H₁₁O₃",
      molecularWeight: "194.20 g/mol",
      description:
        "Propyl Gallate is a synthetic antioxidant used primarily as a food preservative to prevent the oxidation of fats and oils. It is the ester of gallic acid and propanol and is commonly used in food, cosmetics, and pharmaceutical products.",
      additionalInfo:
        "Derived from natural sources such as palm oil or synthesized chemically, this versatile compound is highly valued in the cosmetics, personal care, and pharmaceutical industries. Propyl Gallate helps extend the shelf life of products by inhibiting the degradation of fats and oils due to oxidative processes.",
      industries: [
        {
          title: "Food and Beverage Industry",
          items: [
            {
              label: "Preservative and Flavor Enhancer",
              description: [
                "Propyl Gallate is widely used in food products, particularly in oils, fats, and processed foods, to prevent rancidity caused by oxidation. It is often found in products like margarine, salad dressings, and packaged snacks.",
                "It is also used in processed meats, beverages, and confectionery to maintain product quality and extend shelf life.",
              ],
            },
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          items: [
            {
              label: "Antioxidant and Preservative",
              description: [
                "Propyl Gallate is used in cosmetics and skincare formulations to prevent the oxidation of oils and active ingredients, helping to preserve the efficacy and stability of products such as creams, lotions, and shampoos.",
                "It is included in cosmetic formulations to prevent the degradation of fats and oils, maintaining the quality and safety of the products.",
              ],
            },
          ],
        },
        {
          title: "Pharmaceuticals",
          items: [
            {
              label: "Antioxidant and Preservative",
              description: [
                "Propyl Gallate is used in the pharmaceutical industry to stabilize formulations that contain oils, such as oral suspensions and certain injectable drugs, by preventing oxidative degradation.",
                "It is also used as a preservative in some pharmaceutical products, helping to maintain the stability and shelf life of formulations.",
              ],
            },
          ],
        },
      ],
      specifications: [
        { label: "CAS No", value: "121-79-9" },
        { label: "EC Number", value: "204-798-4" },
        { label: "Appearance", value: "White to off-white crystalline powder" },
        { label: "Molecular Weight", value: "194.20 g/mol" },
        { label: "Molecular Formula", value: "C₁₁H₁₁O₃" },
        {
          label: "Solubility",
          value:
            "Soluble in ethanol, acetone, and chloroform; slightly soluble in water",
        },
        { label: "Boiling Point", value: "Not available" },
        { label: "Odor", value: "Odorless" },
        { label: "Melting Point", value: "122–126°C" },
        { label: "Density", value: "1.26 g/cm³" },
        { label: "pH (1% Solution)", value: "5.0–7.0" },
        { label: "Assay", value: "≥99%" },
        { label: "Heavy Metals", value: "≤10 ppm" },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/chem_19.jpg",
      imageAlt: "Leucine",
      imageTitle: "Leucine",
      productName: "LEUCINE",
      chemicalName: "Leucine",
      casNumber: "61-90-5",
      chemicalFormula: "C₆H₁₃NO₂",
      molecularWeight: "131.17 g/mol",
      description:
        "Leucine is an essential branched-chain amino acid (BCAA) that plays a vital role in protein synthesis and metabolic regulation. It is commonly found in dietary proteins such as meat, dairy products, and legumes.",
      additionalInfo:
        "Leucine is critical for muscle growth and repair, making it a popular supplement among athletes and bodybuilders. It is also used in the medical field for the treatment of various conditions, including malnutrition and muscle wasting diseases.",
      industries: [
        {
          title: "Muscle Growth and Recovery",
          items: [
            {
              label: "Protein Synthesis and Muscle Protection",
              description: [
                "Leucine is known for its ability to stimulate muscle protein synthesis, making it a key amino acid for promoting muscle growth and recovery after exercise. It is often included in dietary supplements for athletes and bodybuilders to enhance performance and recovery.",
                "Leucine helps prevent muscle protein breakdown (catabolism), particularly during periods of fasting, intense exercise, or stress.",
              ],
            },
          ],
        },
        {
          title: "Nutritional Supplements",
          items: [
            {
              label: "Support for Muscle Health and Nutrition",
              description: [
                "Leucine is one of the three BCAAs, along with isoleucine and valine, and is often used in combination with these amino acids in dietary supplements to support muscle health, endurance, and recovery.",
                "Leucine is used in nutritional supplements for patients suffering from malnutrition, muscle wasting, or other conditions that require enhanced protein intake.",
              ],
            },
          ],
        },
        {
          title: "Medical Applications",
          items: [
            {
              label: "Treatment and Recovery Aid",
              description: [
                "Leucine is used in the management of conditions like cachexia (muscle wasting), particularly in patients with chronic illnesses such as cancer or AIDS. It helps to improve muscle mass and overall nutritional status.",
                "Leucine supplementation may be recommended for elderly individuals or patients recovering from surgery to help maintain muscle mass and improve recovery outcomes.",
              ],
            },
          ],
        },
      ],
      specifications: [
        { label: "CAS No", value: "61-90-5" },
        { label: "EC Number", value: "200-492-9" },
        { label: "Appearance", value: "White crystalline powder" },
        { label: "Molecular Weight", value: "131.17 g/mol" },
        { label: "Molecular Formula", value: "C₆H₁₃NO₂" },
        {
          label: "Solubility",
          value: "Soluble in water, slightly soluble in ethanol",
        },
        { label: "Boiling Point", value: "Not available" },
        { label: "Odor", value: "Odorless" },
        { label: "Melting Point", value: "293–295°C" },
        { label: "Density", value: "Not applicable" },
        { label: "pH (1% Solution)", value: "5.5–7.0" },
        { label: "Assay", value: "≥98%" },
        { label: "Heavy Metals", value: "≤10 ppm" },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/chem_27.jpg",
      imageAlt: "Florfenicol",
      imageTitle: "Florfenicol",
      productName: "CITRIC ACIDS (ANHYDROUS)",
      chemicalName: "Florfenicol",
      casNumber: "73231-34-2",
      chemicalFormula: "C₁₈H₂₀Cl₂FN₃O₅",
      molecularWeight: "358.27 g/mol",
      description:
        "Florfenicol is a broad-spectrum antibiotic primarily used in veterinary medicine. It is a synthetic analog of thiamphenicol, used to treat bacterial infections in animals. Florfenicol inhibits bacterial protein synthesis by binding to the bacterial ribosome, preventing the growth of bacteria.",
      additionalInfo:
        "It is effective against a wide range of Gram-positive and Gram-negative bacteria, including those responsible for respiratory infections, gastrointestinal infections, and skin infections in livestock and poultry.",
      industries: [
        {
          title: "Veterinary Medicine",
          items: [
            {
              label: "Treatment of Infections in Livestock",
              description: [
                "Florfenicol is commonly used to treat respiratory infections in cattle, swine, and poultry caused by pathogens such as Pasteurella spp., Actinobacillus pleuropneumonia, and Haemophilus spp.",
                "It is used to treat gastrointestinal infections in animals caused by susceptible bacteria, such as E. coli and Salmonella.",
                "Florfenicol is effective against skin infections in animals, including abscesses and wounds caused by bacterial pathogens.",
              ],
            },
          ],
        },
        {
          title: "Fish Farming (Aquaculture)",
          items: [
            {
              label: "Treatment of Bacterial Fish Diseases",
              description: [
                "In aquaculture, Florfenicol is used to treat bacterial infections in fish, such as Vibrio spp. and Aeromonas spp., which can cause significant losses in fish populations.",
              ],
            },
          ],
        },
        {
          title: "Prophylactic Use in Livestock",
          items: [
            {
              label: "Infection Prevention in High-Risk Animals",
              description: [
                "Florfenicol is used as a prophylactic treatment to prevent infections in livestock, particularly in high-risk populations or after surgery.",
              ],
            },
          ],
        },
      ],
      specifications: [
        { label: "CAS No", value: "73231-34-2" },
        { label: "EC Number", value: "277-931-7" },
        { label: "Appearance", value: "White to off-white crystalline powder" },
        { label: "Molecular Weight", value: "358.27 g/mol" },
        { label: "Molecular Formula", value: "C₁₈H₂₀Cl₂FN₃O₅" },
        { label: "Boiling Point", value: "Not available" },
        { label: "Solubility", value: "Soluble in water and ethanol" },
        { label: "Odor", value: "Odorless" },
        { label: "Melting Point", value: "158–160°C" },
        { label: "pH (1% Solution)", value: "4.5–7.0" },
        { label: "Density", value: "Not applicable" },
        { label: "Assay", value: "≥98%" },
        { label: "Heavy Metals", value: "≤10 ppm" },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/meb.png",
      imageAlt: "Mebeverine Hydrochloride",
      imageTitle: "Mebeverine Hydrochloride",
      productName: "MEBEVERINE HYDROCHLORIDE",
      chemicalName: "Mebeverine Hydrochloride",
      casNumber: "5630-53-5",
      chemicalFormula: "C₁₉H₂₆ClNO₃",
      molecularWeight: "343.87 g/mol",
      description:
        "Mebeverine Hydrochloride (HCl) is an antispasmodic medication commonly used to treat gastrointestinal disorders such as irritable bowel syndrome (IBS) and other conditions that involve smooth muscle spasm.",
      additionalInfo:
        "It works by relaxing the muscles in the gut, relieving pain, discomfort, and cramping associated with these conditions. Mebeverine HCl is typically administered in oral form as tablets or capsules and is known for its ability to target the smooth muscle of the gastrointestinal tract without affecting the central nervous system.",
      industries: [
        {
          title: "Treatment of Irritable Bowel Syndrome (IBS)",
          items: [
            {
              label: "Relief of Abdominal Pain and Discomfort",
              description: [
                "Mebeverine HCl is commonly used to relieve symptoms of IBS, including abdominal pain, bloating, and discomfort. It works by relaxing the smooth muscle of the intestines, reducing spasms and improving bowel function.",
                "It helps regulate bowel movements by reducing the spasms that can lead to diarrhea or constipation in IBS patients.",
              ],
            },
          ],
        },
        {
          title: "Gastrointestinal Disorders",
          items: [
            {
              label: "Spasms in the Digestive Tract",
              description: [
                "Mebeverine HCl is used to treat other gastrointestinal disorders that involve smooth muscle spasms, such as colitis or spastic colon. It can reduce pain and improve overall gastrointestinal motility.",
                "It is sometimes used after abdominal surgery to relieve bowel dysfunction caused by spasm and to aid in post-operative recovery.",
              ],
            },
          ],
        },
        {
          title: "Symptom Management in Other Digestive Disorders",
          items: [
            {
              label: "Functional Digestive Disorders",
              description: [
                "Mebeverine HCl is helpful in managing functional digestive disorders that cause discomfort, bloating, and irregular bowel movements, improving the quality of life for patients with these conditions.",
              ],
            },
          ],
        },
      ],
      specifications: [
        { label: "CAS No", value: "5630-53-5" },
        { label: "EC Number", value: "227-085-3" },
        { label: "Molecular Formula", value: "C₁₉H₂₆ClNO₃" },
        { label: "Molecular Weight", value: "343.87 g/mol" },
        { label: "Appearance", value: "White to off-white crystalline powder" },
        { label: "Odor", value: "Odorless" },
        {
          label: "Solubility",
          value: "Slightly soluble in water, soluble in ethanol",
        },
        { label: "Melting Point", value: "134–136°C" },
        { label: "Boiling Point", value: "Not available" },
        { label: "Density", value: "Not applicable" },
        { label: "pH (1% solution)", value: "4.5–6.5" },
        { label: "Assay (Purity)", value: "≥98%" },
        { label: "Heavy Metals", value: "≤10 ppm" },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/chem_29.jpg",
      imageAlt: "1-Pentanol",
      imageTitle: "1-Pentanol",
      productName: "VITAMIN D3",
      chemicalName: "Cholecalciferol",
      casNumber: "67-97-0",
      chemicalFormula: "C₂₇H₄₄O₁₁",
      molecularWeight: "384.6 g/mol",
      description:
        "Vitamin D3 (1,000,000 IU/gm), also known as Cholecalciferol, is a highly concentrated form of Vitamin D. It is a fat-soluble vitamin that plays a crucial role in calcium absorption, bone health, immune function, and overall health. This form of Vitamin D3 is typically used in dietary supplements, fortified foods, and pharmaceutical formulations. The high potency of 1,000,000 IU per gram makes it suitable for highly concentrated formulations where small amounts of the active ingredient are required.",
      additionalInfo:
        "Vitamin D3 is essential for maintaining proper bone health and immune function. It is commonly used in the treatment and prevention of Vitamin D deficiency, especially in individuals with limited sun exposure or those with certain medical conditions.",
      industries: [
        {
          title: "Bone Health",
          items: [
            {
              label: "Calcium Absorption",
              description: [
                "Vitamin D3 promotes the absorption of calcium and phosphorus in the intestines, which is essential for maintaining strong bones and teeth. It helps prevent conditions like rickets and osteomalacia.",
              ],
            },
            {
              label: "Bone Density",
              description: [
                "Adequate Vitamin D3 levels help maintain bone density and reduce the risk of fractures, especially in older adults.",
              ],
            },
          ],
        },
        {
          title: "Immune System Support",
          items: [
            {
              label: "Immune Function",
              description: [
                "Vitamin D3 plays a vital role in modulating the immune system. It enhances the pathogen-fighting effects of immune cells and reduces inflammation, supporting overall immune health.",
              ],
            },
            {
              label: "Protection Against Infections",
              description: [
                "Vitamin D3 has been shown to reduce the risk of respiratory infections, such as the flu and common cold.",
              ],
            },
          ],
        },
        {
          title: "Mood and Mental Health",
          items: [
            {
              label: "Mood Regulation",
              description: [
                "Vitamin D3 is believed to influence mood regulation and may help in managing conditions like depression, particularly seasonal affective disorder (SAD).",
              ],
            },
            {
              label: "Cognitive Function",
              description: [
                "Adequate levels of Vitamin D3 are linked to improved cognitive function and a reduced risk of cognitive decline in older adults.",
              ],
            },
          ],
        },
        {
          title: "Dietary Supplementation",
          items: [
            {
              label: "Fortification of Foods",
              description: [
                "Vitamin D3 is commonly used to fortify foods such as milk, cereals, and plant-based alternatives to help prevent Vitamin D deficiency in populations at risk.",
              ],
            },
            {
              label: "Oral Supplements",
              description: [
                "Due to its high potency, Vitamin D3 is often used in concentrated forms in dietary supplements for individuals with low Vitamin D levels or those who have limited sun exposure.",
              ],
            },
          ],
        },
        {
          title: "Support for Healthy Pregnancy",
          items: [
            {
              label: "Pregnancy Health",
              description: [
                "Vitamin D3 is essential for the health of both the mother and the developing baby. It supports fetal bone development and helps prevent complications such as preeclampsia.",
              ],
            },
          ],
        },
      ],
      specifications: [
        { label: "CAS No", value: "67-97-0" },
        { label: "EC Number", value: "200-673-2" },
        { label: "Molecular Formula", value: "C₂₇H₄₄O₁₁" },
        { label: "Molecular Weight", value: "384.6 g/mol" },
        { label: "Appearance", value: "White to off-white crystalline powder" },
        { label: "Odor", value: "Odorless" },
        { label: "Solubility", value: "Soluble in fat, ethanol, and oils" },
        {
          label: "pH (1% solution)",
          value: "Not applicable (fat-soluble compound)",
        },
        { label: "Assay (Purity)", value: "≥1,000,000 IU/g" },
        { label: "Heavy Metals", value: "≤10 ppm" },
        { label: "Loss on Drying", value: "≤5%" },
        {
          label: "Microbial Limit",
          value: "Meets the standard for dietary supplements",
        },
        {
          label: "Shelf Life",
          value: "24–36 months (depending on packaging and storage conditions)",
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/AMOXICILLIN-TRIHYDRATE.jpg",
      imageAlt: "Amoxicillin Trihydrate (Light)",
      imageTitle: "Amoxicillin Trihydrate (Light)",
      productName: "AMOXICILLIN TRIHYDRATE (LIGHT)",
      chemicalName: "Amoxicillin Trihydrate (Light)",
      casNumber: "61336-70-7",
      chemicalFormula: "C₁₆H₁₉N₃O₅S·3H₂O",
      molecularWeight: "419.45 g/mol",
      description:
        "Amoxicillin Trihydrate (Light) is a broad-spectrum beta-lactam antibiotic belonging to the penicillin class. It is widely used for the treatment of bacterial infections caused by gram-positive and gram-negative organisms. Amoxicillin works by inhibiting the synthesis of bacterial cell walls, making it effective against a wide range of infections.",
      additionalInfo:
        "Amoxicillin Trihydrate (Light) is commonly used to treat infections such as pneumonia, bronchitis, and ear infections. It is typically prescribed to fight both gram-positive and gram-negative bacteria, with applications across various therapeutic areas.",
      specifications: [
        { label: "CAS No", value: "61336-70-7" },
        { label: "EC Number", value: "262-101-7" },
        { label: "Appearance", value: "White to off-white crystalline powder" },
        { label: "Molecular Weight", value: "419.45 g/mol" },
        { label: "Molecular Formula", value: "C₁₆H₁₉N₃O₅S·3H₂O" },
        {
          label: "Solubility",
          value: "Slightly soluble in water, sparingly soluble in ethanol",
        },
        { label: "Purity", value: "≥95.0% (USP/BP/EP Standards)" },
        { label: "Odor", value: "Odorless" },
        {
          label: "Melting Point",
          value: "Decomposes without a defined melting point",
        },
        { label: "pH (Solution)", value: "3.5–5.5 (in a 1% aqueous solution)" },
        { label: "Loss on Drying", value: "≤3.0%" },
        { label: "Residue on Ignition", value: "≤0.1%" },
        { label: "Specific Optical Rotation", value: "+290° to +315°" },
      ],
      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Oral Formulations and Antibiotics",
              description: [
                "Used in the formulation of oral capsules, tablets, and suspensions for treating bacterial infections.",
                "Commonly prescribed for respiratory tract infections, urinary tract infections, skin infections, and ear infections.",
                "Utilized in combination therapies, such as Amoxicillin-Clavulanate formulations, to combat beta-lactamase-producing bacteria.",
              ],
            },
          ],
        },
        {
          title: "Veterinary Medicine",
          items: [
            {
              label: "Animal Antibiotics",
              description: [
                "Administered to animals for treating bacterial infections in livestock and pets.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl:
        "./assets/img/api-excipients/AMOXICILLIN-TRIHYDRATE-(COMPACTED).jpg",
      imageAlt: "Amoxicillin Trihydrate (Compacted)",
      imageTitle: "Amoxicillin Trihydrate (Compacted)",
      productName: "AMOXICILLIN TRIHYDRATE (COMPACTED)",
      chemicalName: "Amoxicillin Trihydrate (Compacted)",
      casNumber: "61336-70-7",
      chemicalFormula: "C₁₆H₁₉N₃O₅S·3H₂O",
      molecularWeight: "419.45 g/mol",
      description:
        "Amoxicillin Trihydrate (Compacted) is a semi-synthetic, broad-spectrum antibiotic belonging to the penicillin class. The compacted form provides improved flowability and ease of handling during pharmaceutical manufacturing processes.",
      additionalInfo:
        "It retains the same active pharmaceutical properties as standard Amoxicillin Trihydrate and is commonly used in the production of tablets and capsules.",
      specifications: [
        { label: "CAS No", value: "61336-70-7" },
        { label: "EC Number", value: "262-101-7" },
        { label: "Appearance", value: "White to off-white compacted granules" },
        { label: "Molecular Weight", value: "419.45 g/mol" },
        { label: "Molecular Formula", value: "C₁₆H₁₉N₃O₅S·3H₂O" },
        {
          label: "Solubility",
          value: "Slightly soluble in water, sparingly soluble in ethanol",
        },
        { label: "Purity", value: "≥95.0% (USP/BP/EP Standards)" },
        { label: "Odor", value: "Odorless" },
        { label: "Bulk Density", value: "Typically 0.55–0.75 g/cm³" },
        { label: "pH (Solution)", value: "3.5–5.5 (in a 1% aqueous solution)" },
        { label: "Loss on Drying", value: "≤3.0%" },
        { label: "Residue on Ignition", value: "≤0.1%" },
        { label: "Specific Optical Rotation", value: "+290° to +315°" },
      ],
      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Tablets and Capsules",
              description: [
                "The compacted form is specifically designed for direct compression in tablet manufacturing.",
                "Improves production efficiency by enhancing flowability and reducing dust formation.",
              ],
            },
            {
              label: "Suspensions",
              description: [
                "Utilized in oral liquid formulations for pediatric and geriatric patients.",
                "Effective against bacterial infections, including respiratory tract infections, urinary tract infections, and skin infections.",
              ],
            },
          ],
        },
        {
          title: "Veterinary Medicine",
          items: [
            {
              label: "Oral Dosage Forms",
              description: [
                "Used in formulations for treating bacterial infections in animals, particularly in oral dosage forms.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/IRBESARTAN.png",
      imageAlt: "Irbesartan",
      imageTitle: "Irbesartan",
      productName: "IRBESARTAN",
      chemicalName: "Irbesartan",
      casNumber: "138402-11-6",
      chemicalFormula: "C₂₅H₂₈N₆O",
      molecularWeight: "428.53 g/mol",
      description:
        "Irbesartan is an angiotensin II receptor antagonist (ARB) used primarily for the treatment of hypertension and diabetic nephropathy in patients with type 2 diabetes.",
      additionalInfo:
        "It works by blocking the effects of angiotensin II, thereby relaxing blood vessels and reducing blood pressure.",

      specifications: [
        { label: "CAS No", value: "138402-11-6" },
        { label: "EC Number", value: "604-050-1" },
        { label: "Appearance", value: "White to off-white crystalline powder" },
        { label: "Molecular Weight", value: "428.53 g/mol" },
        { label: "Molecular Formula", value: "C₂₅H₂₈N₆O" },
        {
          label: "Solubility",
          value:
            "Practically insoluble in water; soluble in methanol and slightly soluble in ethanol",
        },
        { label: "Purity", value: "≥99.0% (USP/BP/EP Standards)" },
        { label: "Odor", value: "Odorless" },
        { label: "Melting Point", value: "180–181°C" },
        { label: "Specific Optical Rotation", value: "Not applicable" },
        { label: "Loss on Drying", value: "≤0.5%" },
        { label: "Residue on Ignition", value: "≤0.1%" },
        { label: "Heavy Metals", value: "≤20 ppm" },
      ],

      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Tablets and Capsules",
              description: [
                "Formulated as monotherapy or in combination with other antihypertensive agents such as hydrochlorothiazide.",
              ],
            },
            {
              label: "Hypertension Management",
              description: [
                "Reduces the risk of cardiovascular events in patients with high blood pressure.",
              ],
            },
            {
              label: "Diabetic Nephropathy",
              description: [
                "Slows the progression of kidney disease in patients with type 2 diabetes and hypertension.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/SULPIRIDE.jpg",
      imageAlt: "Sulpiride",
      imageTitle: "Sulpiride",
      productName: "SULPIRIDE",
      chemicalName: "Sulpiride",
      casNumber: "1131-66-8",
      chemicalFormula: "C₁₂H₁₉N₃O₄S",
      molecularWeight: "285.37 g/mol",
      description:
        "Sulpiride is an atypical antipsychotic drug that belongs to the class of substituted benzamides. It is primarily used in the treatment of schizophrenia, depression, and anxiety disorders.",
      additionalInfo:
        "Sulpiride works by selectively blocking dopamine receptors in the brain, which helps in managing symptoms associated with psychiatric conditions. It is also sometimes used to treat gastrointestinal disorders due to its prokinetic properties.",
      specifications: [
        { label: "CAS No", value: "1131-66-8" },
        { label: "EC Number", value: "214-779-3" },
        { label: "Appearance", value: "White to off-white crystalline powder" },
        { label: "Molecular Weight", value: "285.37 g/mol" },
        { label: "Molecular Formula", value: "C₁₂H₁₉N₃O₄S" },
        {
          label: "Solubility",
          value: "Soluble in water, ethanol, and methanol",
        },
        { label: "Purity", value: "≥98.0% (USP/BP/EP Standards)" },
        { label: "Odor", value: "Odorless" },
        { label: "Melting point", value: "195–198°C" },
        { label: "Loss on Drying", value: "≤0.5%" },
        { label: "Residue on Ignition", value: "≤0.1%" },
        { label: "Heavy Metal", value: "≤10 ppm" },
      ],
      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Antipsychotic Treatment",
              description: [
                "Administered to animals for treating bacterial infections in livestock and pets.",
              ],
            },
            {
              label: "Antidepressant",
              description: [
                "Sometimes prescribed for the treatment of depression, particularly in patients who do not respond to other medications.",
              ],
            },
            {
              label: "Gastrointestinal Disorders",
              description: [
                "Used as a prokinetic agent to treat conditions like dyspepsia (indigestion) and irritable bowel syndrome (IBS).",
              ],
            },
          ],
        },
        {
          title: "Other Uses",
          items: [
            {
              label: "Anxiolytic",
              description: [
                "In some cases, sulpiride is used to treat anxiety disorders.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/MAGNESIUM-SULPHATE.jpg",
      imageAlt: "Magnesium Sulphate",
      imageTitle: "Magnesium Sulphate",
      productName: "MAGNESIUM SULPHATE",
      chemicalName: "Magnesium Sulphate",
      casNumber: "7487-88-9",
      chemicalFormula: "MgSO₄",
      molecularWeight: "120.37 g/mol",
      description:
        "Magnesium Sulphate (MgSO₄) is an inorganic salt commonly used in a variety of industrial, agricultural, and medical applications. It is available in several forms, including the heptahydrate (MgSO₄·7H₂O) and anhydrous forms.",
      additionalInfo:
        "Magnesium Sulphate is highly soluble in water and is primarily known for its use in agriculture as a fertilizer and in medicine for treating magnesium deficiencies, muscle spasms, and eclampsia.",
      specifications: [
        { label: "CAS No", value: "7487-88-9" },
        { label: "EC Number", value: "231-298-2" },
        { label: "Appearance", value: "White crystalline or granular powder" },
        { label: "Molecular Weight", value: "120.37 g/mol" },
        { label: "Molecular Formula", value: "MgSO₄" },
        { label: "Solubility", value: "Soluble in water (very soluble)" },
        { label: "Purity", value: "≥99.0% (USP/BP/EP Standards)" },
        { label: "Odor", value: "Odorless" },
        { label: "Melting point", value: "1124°C (decomposes)" },
        { label: "Loss on Drying", value: "≤0.5%" },
        { label: "Residue on Ignition", value: "≤0.1%" },
        { label: "Heavy Metals", value: "≤10 ppm" },
        {
          label: "pH (Solution)",
          value: "5.5–7.0 (in a 10% aqueous solution)",
        },
      ],

      industries: [
        {
          title: "Agricultural Industry",
          items: [
            {
              label: "Fertilizer",
              description: [
                "Used as a source of magnesium and sulfur for plants, promoting healthy growth, especially in crops like tomatoes, potatoes, and peppers.",
              ],
            },
            {
              label: "Soil Conditioner",
              description: ["Helps improve soil quality and nutrient content."],
            },
          ],
        },
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Magnesium Supplementation",
              description: [
                "Used in intravenous or oral formulations to treat magnesium deficiency or low magnesium levels in the body.",
              ],
            },
            {
              label: "Eclampsia Treatment",
              description: [
                "Administered intravenously to control seizures in pregnant women with preeclampsia or eclampsia.",
              ],
            },
            {
              label: "Laxative",
              description: [
                "Used as a mild laxative in certain medical treatments.",
              ],
            },
          ],
        },
        {
          title: "Industrial Applications",
          items: [
            {
              label: "Manufacturing",
              description: [
                "Used in the production of textiles, paper, and as a component in various chemical processes.",
              ],
            },
            {
              label: "Water Treatment",
              description: [
                "Applied in water treatment processes to remove impurities.",
              ],
            },
          ],
        },
        {
          title: "Cosmetic Industry",
          items: [
            {
              label: "Bath Soaks",
              description: [
                "Often used in bath salts and body scrubs for its soothing and muscle-relaxing properties.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/MAGNESIUM-HYDROXIDE-BP.png",
      imageAlt: "Magnesium Hydroxide BP",
      imageTitle: "Magnesium Hydroxide BP",
      productName: "MAGNESIUM HYDROXIDE BP",
      chemicalName: "Magnesium Hydroxide BP",
      casNumber: "1309-42-8",
      chemicalFormula: "Mg(OH)₂",
      molecularWeight: "58.31 g/mol",
      description:
        "Magnesium Hydroxide BP is a white, odorless powder or paste, commonly used in pharmaceutical and industrial applications.",
      additionalInfo:
        "It is an alkaline compound that is primarily used as an antacid and laxative in medicine. Magnesium Hydroxide is also used in water treatment, as a fire retardant, and in the production of other chemicals.",
      specifications: [
        { label: "CAS No", value: "1309-42-8" },
        { label: "EC Number", value: "2215-170-3" },
        { label: "Appearance", value: "White, odorless, fine powder or paste" },
        { label: "Molecular Weight", value: "58.31 g/mol" },
        { label: "Molecular Formula", value: "Mg(OH)₂" },
        {
          label: "Solubility",
          value:
            "Insoluble in water (slightly soluble in water to form a suspension)",
        },
        { label: "Purity", value: "≥99.0% (BP Standard)" },
        { label: "Odor", value: "Odorless" },
        { label: "Melting point", value: "Decomposes above 350°C" },
        { label: "Loss on Drying", value: "≤1.0%" },
        { label: "Residue on Ignition", value: "≤0.5%" },
        { label: "Heavy Metals", value: "≤10 ppm" },
        { label: "pH (Solution)", value: "9.5–10.5" },
      ],
      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Antacid",
              description: [
                "Used to relieve heartburn, indigestion, and upset stomach by neutralizing excess stomach acid.",
              ],
            },
            {
              label: "Laxative",
              description: [
                "Used as a gentle laxative to treat constipation by drawing water into the intestines to ease bowel movements.",
              ],
            },
          ],
        },
        {
          title: "Water Treatment",
          items: [
            {
              label: "Neutralizing Agent",
              description: [
                "Used in water treatment to neutralize acidic water and adjust pH levels.",
              ],
            },
            {
              label: "Wastewater Treatment",
              description: [
                "Applied in treating wastewater and removing heavy metals from industrial effluents.",
              ],
            },
          ],
        },
        {
          title: "Industrial Applications",
          items: [
            {
              label: "Flame Retardant",
              description: [
                "Used in the production of fire-resistant materials, particularly in plastics and rubber.",
              ],
            },
            {
              label: "Manufacturing of Chemicals",
              description: [
                "Used in the production of other chemicals such as magnesium salts.",
              ],
            },
          ],
        },
        {
          title: "Cosmetic Industry",
          items: [
            {
              label: "Skin Care Products",
              description: [
                "Added to some skin care formulations for its soothing and anti-inflammatory properties.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl:
        "./assets/img/api-excipients/LIQUORICE-(GLYCYRRHIZA)-EXTRACT.png",
      imageAlt: "Liquorice (Glycyrrhiza) Extract 10%",
      imageTitle: "Liquorice (Glycyrrhiza) Extract 10%",
      productName: "LIQUORICE (GLYCYRRHIZA) EXTRACT 10%",
      chemicalName: "Liquorice (Glycyrrhiza) Extract 10%",
      casNumber: "84775-56-6",
      chemicalFormula: "C₁₈H₂₁O₈",
      molecularWeight: "822.89 g/mol Approximately",
      description:
        "Liquorice (Glycyrrhiza) Extract 10% is derived from the root of the Glycyrrhiza plant and contains 10% glycyrrhizin, the primary active compound responsible for its medicinal properties.",
      additionalInfo:
        "It is widely used in traditional medicine for its anti-inflammatory, antioxidant, and soothing properties. The extract is commonly used in pharmaceutical, cosmetic, and food products for its health benefits and characteristic flavor.",
      specifications: [
        { label: "CAS No", value: "84775-56-6" },
        { label: "EC Number", value: "283-636-3" },
        { label: "Appearance", value: "Brown to dark brown liquid or powder" },
        { label: "Molecular Weight", value: "58.31 g/mol" },
        { label: "Molecular Formula", value: "C₁₈H₂₁O₈" },
        {
          label: "Solubility",
          value: "Soluble in water, alcohol, and glycerin",
        },
        { label: "Purity", value: "≥10% Glycyrrhizin (active compound)" },
        { label: "Odor", value: "Characteristic sweet, licorice odor" },
        {
          label: "Viscosity",
          value: "100–300 cP (depending on concentration)",
        },
        { label: "Specific Gravity", value: "1.10–1.15 g/cm³" },
        { label: "Residue on Ignition", value: "≤1.0%" },
        { label: "Heavy Metals", value: "≤10 ppm" },
        { label: "pH (10% aqueous solution)", value: "4.5–6.0" },
      ],
      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Anti-inflammatory and Antioxidant",
              description: [
                "Used in formulations for soothing sore throats, coughs, and other respiratory issues.",
              ],
            },
            {
              label: "Digestive Health",
              description: [
                "Commonly used to treat indigestion, heartburn, and ulcers due to its anti-inflammatory and soothing properties.",
              ],
            },
            {
              label: "Skin Care",
              description: [
                "Used in topical creams and ointments for its anti-inflammatory and healing effects, particularly for conditions like eczema, acne, and psoriasis.",
              ],
            },
          ],
        },
        {
          title: "Cosmetic Industry",
          items: [
            {
              label: "Skin Whitening",
              description: [
                "Incorporated into skin care products for its ability to reduce pigmentation and even out skin tone.",
              ],
            },
            {
              label: "Anti-aging",
              description: [
                "Used in anti-aging formulations for its antioxidant properties to combat free radicals and reduce the appearance of fine lines and wrinkles.",
              ],
            },
          ],
        },
        {
          title: "Food and Beverage Industry",
          items: [
            {
              label: "Flavoring Agent",
              description: [
                "Used as a flavoring agent in candies, beverages, and confectionery due to its characteristic sweet taste.",
              ],
            },
            {
              label: "Herbal Supplements",
              description: [
                "Often included in herbal supplements for its soothing and digestive benefits.",
              ],
            },
          ],
        },
        {
          title: "Traditional Medicine",
          items: [
            {
              label: "Cough and Cold Remedies",
              description: [
                "Used in herbal teas and syrups to treat coughs, colds, and sore throats.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/AZITHROMYCIN-DIHYDRATE.jpg",
      imageAlt: "Azithromycin Dihydrate",
      imageTitle: "Azithromycin Dihydrate",
      productName: "AZITHROMYCIN DIHYDRATE",
      chemicalName: "Azithromycin Dihydrate",
      casNumber: "117772-70-0",
      chemicalFormula: "C₁₇H₂₀N₂O₁₃·H₂O",
      molecularWeight: "749.87 g/mol",
      description:
        "Azithromycin Dihydrate is an antibiotic in the macrolide class, commonly used to treat a variety of bacterial infections.",
      additionalInfo:
        "It is a semi-synthetic derivative of erythromycin and is particularly effective against respiratory, skin, and soft tissue infections, as well as sexually transmitted diseases. The dihydrate form contains water molecules in its crystalline structure, which aids in the solubility and stability of the drug.",
      specifications: [
        { label: "CAS No", value: "117772-70-0" },
        { label: "EC Number", value: "416-450-7" },
        { label: "Appearance", value: "White to off-white crystalline powder" },
        { label: "Molecular Weight", value: "749.87 g/mol" },
        { label: "Molecular Formula", value: "C₁₇H₂₀N₂O₁₃·H₂O" },
        {
          label: "Solubility",
          value: "Soluble in water, methanol, and ethanol",
        },
        { label: "Melting Point", value: "~75°C" },
        { label: "Odor", value: "Odorless" },
        {
          label: "Viscosity",
          value: "100–300 cP (depending on concentration)",
        },
        { label: "Assay (on anhydrous basis)", value: "95–105%" },
        { label: "Loss on Drying", value: "≤5.0%" },
        { label: "Heavy Metals", value: "≤10 ppm" },
        { label: "pH (10% aqueous solution)", value: "4.5–6.0" },
        { label: "AS Number", value: "117772-70-0" },
      ],

      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Antibiotic Treatment",
              description: [
                "Used to treat bacterial infections such as pneumonia, bronchitis, ear infections, and sexually transmitted infections (STIs) like chlamydia and gonorrhea.",
              ],
            },
            {
              label: "Anti-inflammatory",
              description: [
                "Used in the treatment of infections associated with inflammatory conditions, as it also has mild anti-inflammatory effects.",
              ],
            },
            {
              label: "Prophylaxis",
              description: [
                "Employed in some cases as a preventive measure for infections, particularly in immunocompromised patients.",
              ],
            },
          ],
        },
        {
          title: "Veterinary Use",
          items: [
            {
              label: "Animal Infections",
              description: [
                "Used in veterinary medicine to treat bacterial infections in animals, particularly in respiratory infections in livestock and pets.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/METFORMIN-HYDROCHLORIDE.jpg",
      imageAlt: "Metformin Hydrochloride",
      imageTitle: "Metformin Hydrochloride",
      productName: "METFORMIN HYDROCHLORIDE",
      chemicalName: "Metformin Hydrochloride",
      casNumber: "657-24-9",
      chemicalFormula: "C₈H₁₉ClN₄",
      molecularWeight: "165.63 g/mol",
      description:
        "Metformin Hydrochloride (Metformin HCl) is an oral antihyperglycemic drug commonly used in the treatment of type 2 diabetes mellitus.",
      additionalInfo:
        "It works by decreasing glucose production in the liver, decreasing intestinal absorption of glucose, and improving insulin sensitivity. It is widely prescribed as a first-line therapy for type 2 diabetes, often in combination with other antidiabetic medications.",

      specifications: [
        { label: "CAS No", value: "657-24-9" },
        { label: "EC Number", value: "211-766-0" },
        { label: "Appearance", value: "White to off-white crystalline powder" },
        { label: "Molecular Weight", value: "165.63 g/mol" },
        { label: "Molecular Formula", value: "C₈H₁₉ClN₄" },
        { label: "Solubility", value: "Soluble in water" },
        { label: "Melting Point", value: "~223°C (decomposes)" },
        { label: "Odor", value: "Odorless" },
        { label: "Assay (on anhydrous basis)", value: "98.0–102.0%" },
        { label: "Loss on Drying", value: "≤0.5%" },
        { label: "Heavy Metals", value: "≤10 ppm" },
        { label: "pH (10% aqueous solution)", value: "6.0–7.5" },
      ],

      industries: [
        {
          title: "Pharmaceutical Industry",
          items: [
            {
              label: "Diabetes Treatment",
              description: [
                "Metformin is primarily used to manage blood sugar levels in patients with type 2 diabetes. It helps control blood glucose levels without causing a significant increase in insulin secretion.",
              ],
            },
            {
              label: "Polycystic Ovary Syndrome (PCOS)",
              description: [
                "Metformin is sometimes used off-label to treat PCOS, as it helps improve insulin sensitivity and regulate menstrual cycles.",
              ],
            },
            {
              label: "Weight Management",
              description: [
                "Metformin may aid in weight loss in individuals with type 2 diabetes or obesity by improving insulin sensitivity and reducing appetite.",
              ],
            },
          ],
        },
        {
          title: "Veterinary Use",
          items: [
            {
              label: "Animal Infections",
              description: [
                "Although not as common in veterinary medicine, metformin has been studied for its potential use in managing insulin resistance in animals, particularly in horses and pets with obesity or metabolic disorders.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl:
        "./assets/img/api-excipients/NICOTINAMIDE-(INJECTION GRADE).jpg",
      imageAlt: "Nicotinamide (Injection Grade)",
      imageTitle: "Nicotinamide (Injection Grade)",
      productName: "NICOTINAMIDE (INJECTION GRADE)",
      chemicalName: "Nicotinamide",
      casNumber: "98-92-0",
      chemicalFormula: "C₆H₆N₂O",
      molecularWeight: "122.12 g/mol",
      description:
        "Nicotinamide (Injection Grade), also known as Niacinamide, is a form of Vitamin B3 that is used for various medical purposes.",
      additionalInfo:
        "As an injection-grade product, Nicotinamide is typically used in parenteral formulations (injections or infusions) to treat deficiencies, support metabolic health, or provide therapeutic benefits in certain conditions like pellagra or as a part of skin treatments. It is also used as a component in intravenous solutions.",

      specifications: [
        { label: "CAS No", value: "98-92-0" },
        { label: "EC Number", value: "202-713-4" },
        { label: "Appearance", value: "White to off-white crystalline powder" },
        { label: "Molecular Weight", value: "122.12 g/mol" },
        { label: "Molecular Formula", value: "C₆H₆N₂O" },
        {
          label: "Solubility",
          value: "Soluble in water, ethanol, and propylene glycol",
        },
        { label: "Melting Point", value: "130–135°C" },
        { label: "Boiling Point", value: "Not applicable" },
        { label: "Odor", value: "Odorless" },
        { label: "Assay (Purity)", value: "≥99% (as Nicotinamide)" },
        { label: "Density", value: "1.18 g/cm³" },
        { label: "Heavy Metals", value: "≤10 ppm" },
        { label: "pH (1% solution)", value: "5.0–7.0" },
      ],
      industries: [
        {
          title: "Medical and Therapeutic Use",
          items: [
            {
              label: "Treatment of Pellagra",
              description: [
                "Nicotinamide is commonly used in the treatment of pellagra, a disease caused by Vitamin B3 deficiency. It helps restore normal metabolic function and alleviate symptoms such as dermatitis, diarrhea, and dementia.",
              ],
            },
            {
              label: "Metabolic Disorders",
              description: [
                "It is used to address various metabolic disorders, particularly those related to the deficiency of nicotinic acid or its derivatives.",
              ],
            },
          ],
        },
        {
          title: "Skin Care and Dermatology",
          items: [
            {
              label: "Topical Application (Formulation for Skin Injections)",
              description: [
                "Nicotinamide is used in dermatological treatments for its anti-inflammatory properties. It helps in the treatment of acne, rosacea, and hyperpigmentation.",
              ],
            },
            {
              label: "Anti-Aging and Skin Health",
              description: [
                "It is often included in injectable skin care treatments to promote skin repair and reduce visible signs of aging by enhancing skin barrier function and reducing inflammation.",
              ],
            },
          ],
        },
        {
          title: "Intravenous Formulations",
          items: [
            {
              label: "Parenteral Nutrition",
              description: [
                "Nicotinamide is sometimes included in intravenous nutrition formulations to provide essential nutrients to patients unable to consume food orally.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/FOLIC-ACID -(INJECTION GRADE).png",
      imageAlt: "Folic Acid (Injection Grade)",
      imageTitle: "Folic Acid (Injection Grade)",
      productName: "FOLIC ACID (INJECTION GRADE)",
      chemicalName: "Folic Acid",
      casNumber: "59-30-3",
      chemicalFormula: "C₁₉H₁₉N₇O₆",
      molecularWeight: "441.4 g/mol",
      description:
        "Folic Acid (Injection Grade) is a synthetic form of Vitamin B9, used in injectable form for medical treatments.",
      additionalInfo:
        "It is essential for the formation of red blood cells, the proper functioning of the nervous system, and the synthesis of DNA. As an injection-grade product, Folic Acid is typically used to treat or prevent deficiencies, support pregnancy, and address certain types of anemia. It is a yellow to orange crystalline powder that is water-soluble and can be administered intravenously or intramuscularly.",

      specifications: [
        { label: "CAS No", value: "59-30-3" },
        { label: "EC Number", value: "200-415-2" },
        { label: "Appearance", value: "Yellow to orange crystalline powder" },
        { label: "Molecular Weight", value: "441.4 g/mol" },
        { label: "Molecular Formula", value: "C₁₉H₁₉N₇O₆" },
        {
          label: "Solubility",
          value: "Soluble in water, slightly soluble in ethanol",
        },
        { label: "Melting Point", value: "250°C (decomposes)" },
        { label: "Boiling Point", value: "Not applicable" },
        { label: "Odor", value: "Odorless" },
        { label: "Assay (Purity)", value: "≥95% (as Folic Acid)" },
        { label: "Density", value: "1.3 g/cm³" },
        { label: "Heavy Metals", value: "≤10 ppm" },
        { label: "pH (1% solution)", value: "4.5–6.5" },
      ],

      industries: [
        {
          title: "Treatment of Folic Acid Deficiency",
          items: [
            {
              label: "Prevention and Treatment of Anemia",
              description: [
                "Folic Acid is commonly used to treat megaloblastic anemia caused by folate deficiency. It helps stimulate the production of healthy red blood cells.",
              ],
            },
            {
              label: "Folic Acid Deficiency",
              description: [
                "It is used to correct folate deficiencies, which can lead to symptoms such as fatigue, weakness, and irritability.",
              ],
            },
          ],
        },
        {
          title: "Pregnancy Support",
          items: [
            {
              label: "Prevention of Neural Tube Defects",
              description: [
                "Folic Acid is crucial during pregnancy to prevent birth defects in the brain and spinal cord (neural tube defects). It is recommended for women of childbearing age and those in the early stages of pregnancy.",
              ],
            },
            {
              label: "Support for Maternal Health",
              description: [
                "It also supports overall maternal health by aiding in cell division and the formation of the placenta.",
              ],
            },
          ],
        },
        {
          title: "General Health and Wellness",
          items: [
            {
              label: "Cellular Function",
              description: [
                "Folic Acid plays an essential role in DNA synthesis, cell division, and tissue growth. It supports healthy cellular functions throughout the body.",
              ],
            },
            {
              label: "Cardiovascular Health",
              description: [
                "It is sometimes used in conjunction with other treatments to support cardiovascular health by helping to lower homocysteine levels, which can reduce the risk of heart disease.",
              ],
            },
          ],
        },
        {
          title: "Intravenous and Intramuscular Administration",
          items: [
            {
              label: "Parenteral Formulation",
              description: [
                "Folic Acid Injection is typically administered via intravenous or intramuscular injection when oral supplementation is not feasible or when a higher dose is required for immediate correction of deficiency.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/lutein.gif",
      imageAlt: "Lutein 10%",
      imageTitle: "Lutein 10%",
      productName: "LUTEIN 10%",
      chemicalName: "Lutein",
      casNumber: "127-40-2",
      chemicalFormula: "C₆₄H₁₀₄O₁₆",
      molecularWeight: "568.8 g/mol",
      description:
        "Lutein 10% is a carotenoid pigment found naturally in fruits and vegetables, particularly in leafy greens like spinach and kale.",
      additionalInfo:
        "It is an essential antioxidant with potent protective properties, especially for eye health. Lutein is used in various supplements to promote healthy vision, protect against age-related macular degeneration (AMD), and support skin health. The 10% concentration is commonly used in formulations where a moderate dosage of Lutein is required to support these health benefits.",

      specifications: [
        { label: "CAS No", value: "127-40-2" },
        { label: "EC Number", value: "204-535-1" },
        { label: "Molecular Formula", value: "C₆₄H₁₀₄O₁₆" },
        { label: "Molecular Weight", value: "568.8 g/mol" },
        {
          label: "Appearance",
          value: "Orange to red crystalline powder or granules",
        },
        { label: "Odor", value: "Odorless" },
        {
          label: "Solubility",
          value: "Slightly soluble in ethanol, soluble in organic solvents",
        },
        { label: "pH (1% solution)", value: "5.0–7.0" },
        { label: "Assay (Purity)", value: "10% Lutein (active ingredient)" },
        { label: "Loss on Drying", value: "≤5%" },
        {
          label: "Microbial Limit",
          value: "Meets the standard for dietary supplements",
        },
        {
          label: "Shelf Life",
          value: "24–36 months (depending on packaging and storage conditions)",
        },
      ],

      industries: [
        {
          title: "Eye Health",
          items: [
            {
              label: "Protection Against Macular Degeneration",
              description: [
                "Lutein is widely known for its role in protecting the eyes from oxidative stress, particularly in preventing age-related macular degeneration (AMD). It filters harmful blue light and acts as an antioxidant in the retina.",
              ],
            },
            {
              label: "Improved Visual Function",
              description: [
                "Regular supplementation with Lutein is linked to improved visual performance, especially in low-light conditions.",
              ],
            },
          ],
        },
        {
          title: "Skin Health",
          items: [
            {
              label: "Antioxidant Protection",
              description: [
                "Lutein helps protect the skin from UV damage and oxidative stress, reducing the visible effects of aging such as wrinkles and fine lines.",
              ],
            },
            {
              label: "Hydration and Elasticity",
              description: [
                "It may also support skin hydration and elasticity, contributing to a healthy, youthful appearance.",
              ],
            },
          ],
        },
        {
          title: "General Antioxidant Support",
          items: [
            {
              label: "Free Radical Neutralization",
              description: [
                "Lutein is a potent antioxidant that helps neutralize free radicals in the body, supporting overall health and reducing the risk of chronic diseases associated with oxidative stress.",
              ],
            },
          ],
        },
        {
          title: "Dietary Supplements",
          items: [
            {
              label: "Vision and Skin Care Supplements",
              description: [
                "Lutein 10% is commonly included in dietary supplements aimed at promoting eye health, improving skin appearance, and providing antioxidant protection.",
              ],
            },
          ],
        },
      ],
    },
    {
      imageUrl: "./assets/img/api-excipients/vitamin-a.jpg",
      imageAlt: "Vitamin A (Water-Miscible Type 100) Palmitate",
      imageTitle: "Vitamin A (Water-Miscible Type 100) Palmitate",
      productName: "VITAMIN A PALMITATE",
      chemicalName: "Vitamin A (Water-Miscible Type 100) Palmitate",
      casNumber: "79-81-2",
      chemicalFormula: "C₂₆H₄₀O₂",
      molecularWeight: "412.6 g/mol",
      description:
        "Vitamin A (Water-Miscible Type 100) Palmitate is a form of Vitamin A that has been specially formulated to be water-soluble, making it easier to incorporate into aqueous-based products such as beverages, syrups, and oral supplements.",
      additionalInfo:
        "It is a yellow to orange oil that is typically used to fortify foods, nutritional supplements, and cosmetics. This form of Vitamin A is derived from Retinyl Palmitate, a stable ester of retinol (Vitamin A), and provides essential support for vision, immune function, and skin health.",
      specifications: [
        { label: "CAS No", value: "79-81-2" },
        { label: "EC Number", value: "201-228-3" },
        { label: "Molecular Formula", value: "C₂₆H₄₀O₂" },
        { label: "Molecular Weight", value: "412.6 g/mol" },
        { label: "Appearance", value: "Yellow to orange liquid or oil" },
        { label: "Odor", value: "Odorless or mild characteristic odor" },
        {
          label: "Solubility",
          value: "Water-miscible, soluble in organic solvents",
        },
        { label: "pH (1% solution)", value: "5.0–7.0" },
        {
          label: "Viscosity",
          value: "Low viscosity, typical for oil-based formulations",
        },
        { label: "Assay (Purity)", value: "≥100,000 IU/g" },
        { label: "Heavy Metals", value: "≤10 ppm" },
        { label: "Loss on Drying", value: "≤1%" },
        {
          label: "Microbial Limit",
          value: "Meets the standard for dietary supplements",
        },
      ],

      industries: [
        {
          title: "Vision Health",
          items: [
            {
              label: "Prevention of Night Blindness",
              description: [
                "Vitamin A is essential for the formation of rhodopsin, a pigment in the retina that is crucial for low-light vision. Adequate Vitamin A intake helps prevent night blindness and supports overall eye health.",
              ],
            },
            {
              label: "Macular Health",
              description: [
                "It also plays a role in maintaining the health of the macula, reducing the risk of age-related macular degeneration (AMD).",
              ],
            },
          ],
        },
        {
          title: "Immune System Support",
          items: [
            {
              label: "Boosting Immunity",
              description: [
                "Vitamin A enhances immune function by supporting the production and function of white blood cells, which help fight infections.",
              ],
            },
            {
              label: "Skin and Mucosal Integrity",
              description: [
                "It helps maintain the integrity of skin and mucosal barriers, which are the body’s first line of defense against pathogens.",
              ],
            },
          ],
        },
        {
          title: "Skin Health",
          items: [
            {
              label: "Skin Cell Growth",
              description: [
                "Vitamin A is involved in the regulation of skin cell growth and differentiation. It helps prevent dry, flaky skin and supports overall skin health.",
              ],
            },
            {
              label: "Anti-Aging",
              description: [
                "Vitamin A derivatives, including retinoids, are used in cosmetics for their anti-aging properties, promoting collagen production and reducing the appearance of wrinkles and fine lines.",
              ],
            },
          ],
        },
        {
          title: "Dietary Supplements",
          items: [
            {
              label: "Fortification of Foods",
              description: [
                "Vitamin A Palmitate is widely used in the fortification of foods, particularly in dairy products, cereals, and baby foods, to prevent Vitamin A deficiency.",
              ],
            },
            {
              label: "Oral Supplements",
              description: [
                "It is commonly used in dietary supplements designed to improve overall health, support vision, and boost immunity.",
              ],
            },
          ],
        },
      ],
    },
  ];

  useEffect(() => {
    const matchedProduct = products.find(
      (p) => p.productName.toLowerCase() === productName.toLowerCase()
    );
    setProduct(matchedProduct || null);
  }, [productName]);

  if (!product) {
    return (
      <>
        <Notfound />
      </>
    );
  }

  return (
    <div>
      <Breadcrumb
        title={productName}
        backgroundImage={"./assets/img/contact-banner.png"}
        height="40vh"
      ></Breadcrumb>
      <ProductDetails {...product} />

      <div className="container-xl py-5">
        <div className="row">
          <div className="col-lg-8 pe-lg-4">
            <h2 className="text-primary mb-3">Industrial Uses</h2>
            <IndustryList industries={product.industries} />
          </div>
          <div className="col-lg-4 ps-lg-5">
            <div className="card mb-4">
              <div className="card-body">
                <h2 className="text-primary mb-3">Specifications</h2>
                <SpecificationsCard specifications={product.specifications} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductContentCard;

// ProductDetails Component
const ProductDetails = ({
  imageUrl,
  imageAlt,
  imageTitle,
  productName,
  chemicalName,
  casNumber,
  chemicalFormula,
  molecularWeight,
  density,
  description,
  additionalInfo,
}) => (
  <div className="container-xl py-3 py-md-5">
    <div className="row align-items-xl-center">
      <div className="col-md-4 order-md-2 text-center text-md-end">
        <p className="mb-4 mb-md-0">
          <img
            src={imageUrl}
            className="img-fluid"
            loading="lazy"
            alt={imageAlt}
            title={imageTitle}
          />
        </p>
      </div>
      <div className="col-md-8 order-md-1">
        <div className="heading mb-4 align-class">
          <h2 className="heading1 t-al-left" style={{ color: "#105681" }}>
            {productName}
          </h2>
          <p className="text-dark fw-medium t-al-left">
            <i>{chemicalName}</i>
          </p>
        </div>
        <div className="row row-cols-2 row-prod-border row-cols-sm-auto mb-2">
          {casNumber && (
            <div className="col">
              <p>
                <small className="d-block fw-bold">CAS</small> {casNumber}
              </p>
            </div>
          )}
          {chemicalFormula && (
            <div className="col">
              <p>
                <small className="d-block fw-bold">Chemical Formula</small>{" "}
                {chemicalFormula}
              </p>
            </div>
          )}
          {molecularWeight && (
            <div className="col">
              <p>
                <small className="d-block fw-bold">Molecular Weight</small>{" "}
                {molecularWeight}
              </p>
            </div>
          )}
          {density && (
            <div className="col">
              <p>
                <small className="d-block fw-bold">
                  Density/Specific Gravity
                </small>{" "}
                {density}
              </p>
            </div>
          )}
        </div>
        <div>
          <p>{description}</p>
          <p>{additionalInfo}</p>
        </div>
      </div>
    </div>
  </div>
);

// IndustryList Component
const IndustryList = ({ industries }) => (
  <ul className="list-decimal pl-5 space-y-4">
    {industries.map((industry, index) => (
      <li key={index} className="font-bold">
        {industry.title}
        <ul className="list-disc pl-5 space-y-2">
          {industry.items.map((item, subIndex) => (
            <li key={subIndex}>
              <strong>{item.label}</strong> {item.description}
            </li>
          ))}
        </ul>
      </li>
    ))}
  </ul>
);

// SpecificationsCard Component
// const SpecificationsCard = ({ specifications }) => (
//   <table className="w-full border-collapse">
//     <tbody>
//       {specifications.map((spec, index) => (
//         <tr key={index} className="border-b">
//           <th className="text-primary font-medium text-left py-2 pr-4">
//             {spec.label}
//           </th>
//           <td className="py-2">
//             {spec.value.includes(",") ? (
//               <div className="whitespace-pre-line">
//                 {spec.value.split(",").map((line, i) => (
//                   <div key={i}>{line.trim()}</div>
//                 ))}
//               </div>
//             ) : (
//               spec.value
//             )}
//           </td>
//         </tr>
//       ))}
//     </tbody>
//   </table>
// );

// 2

// const SpecificationsCard = ({ specifications }) => (
//   <div className="table-responsive p-3">
//     <table className="table table-bordered table-striped shadow-sm">
//       <tbody>
//         {specifications.map((spec, index) => (
//           <tr key={index}>
//             <th className="bg-light text-primary text-start p-3 w-25">
//               {spec.label}
//             </th>
//             <td className="p-3 text-secondary">
//               {spec.value.includes(",") ? (
//                 <div>
//                   {spec.value.split(",").map((line, i) => (
//                     <div key={i} className="py-1">
//                       {line.trim()}
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 spec.value
//               )}
//             </td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

const SpecificationsCard = ({ specifications }) => (
  <div className="table-container">
    <table className="table custom-table">
      <tbody>
        {specifications.map((spec, index) => (
          <tr key={index} className="custom-row">
            <th className="custom-header">{spec.label}</th>
            <td className="custom-value">
              {spec.value.includes(",") ? (
                <div>
                  {spec.value.split(",").map((line, i) => (
                    <div key={i} className="py-1">
                      {line.trim()}
                    </div>
                  ))}
                </div>
              ) : (
                spec.value
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
